export const computeRouteEntries = {
  clientDeviceInstances: () => import('./presentation/ClientDeviceInstancesPage'),
  deviceInstanceDetail: () => import('./presentation/DeviceInstanceDetailPage'),
  vmsList: () => import('./presentation/VMsListPage'),
  vmForm: () => import('./presentation/VMFormPage'),
  vmDetail: () => import('./presentation/VmDetailPage'),
  vmClustersList: () => import('./presentation/VMClustersListPage'),
  vmClusterForm: () => import('./presentation/VMClusterFormPage'),
  vmClusterDetail: () => import('./presentation/VMClusterDetailPage'),
  devicesList: () => import('./presentation/DevicesListPage'),
  deviceForm: () => import('./presentation/DeviceFormPage'),
  deviceDetail: () => import('./presentation/DeviceDetailPage'),
} as const;